import React from 'react';
import clsx from 'clsx';
import styles from './UIGameHelpUserSettingsButton.module.scss';
import { Dropdown, T } from '@colonist/ui';
import { ModeSettingEnum } from '@colonist/types';
import IconSettings from '@static/images/icon_settings.svg';
import { useUIGameHelpRulesButtonContext } from '../UIGameHelpRulesButton/UIGameHelpRulesButtonContext.tsx';
import { useUIGameHelpLeaveGameContext } from '../UIGameHelpLeaveGameContext.tsx';
import { useGameStore } from '../../../store/GameStoreContext.ts';
import { useIsReplay } from '../../../store/selectors/useIsReplay.ts';
import { UIGameFloatingText } from '../../../common/UIGameFloatingText/index.ts';
export const UIGameHelpUserSettingsButton = ({ className, isPlayerSpectator, isRulesOptionVisible, onSettingsClick, onPauseGameClick, onDisableKarmaClick })=>{
    const { showRulesPopup } = useUIGameHelpRulesButtonContext();
    const { canResign, leaveGame } = useUIGameHelpLeaveGameContext();
    const modeSetting = useGameStore((state)=>state.gameSettings.modeSetting);
    const isKarmaActive = useGameStore((state)=>state.gameSettings.isKarmaActive);
    const hasUsedDisableKarmaRequest = useGameStore((state)=>state.hasUsedDisableKarmaRequest);
    const isReplay = useIsReplay();
    const isBeginnerMode = modeSetting === ModeSettingEnum.BeginnerModeClassic4P;
    const getDisableKarmaLabelKey = ()=>{
        if (!isKarmaActive) return 'strings:game.gearIcon.karmaDisabled';
        return 'strings:game.gearIcon.disableKarma';
    };
    const disableKarmaLabelText = /*#__PURE__*/ React.createElement(T, {
        id: {
            key: getDisableKarmaLabelKey()
        }
    });
    const handleDisableKarmaClick = ()=>{
        if (!hasUsedDisableKarmaRequest) onDisableKarmaClick();
    };
    const options = [
        {
            label: /*#__PURE__*/ React.createElement(T, {
                id: {
                    key: 'strings:game.gearIcon.settings'
                }
            }),
            onClick: onSettingsClick
        },
        {
            label: /*#__PURE__*/ React.createElement(T, {
                id: {
                    key: 'strings:game.gearIcon.pauseGame'
                }
            }),
            onClick: onPauseGameClick,
            disabled: isPlayerSpectator,
            hidden: isReplay
        },
        {
            label: hasUsedDisableKarmaRequest ? /*#__PURE__*/ React.createElement(UIGameFloatingText, {
                direction: "up",
                text: {
                    key: 'strings:game.gameState.gameLogs.youCanOnlyStartAVoteToDisableKarmaOnce'
                }
            }, disableKarmaLabelText) : disableKarmaLabelText,
            onClick: handleDisableKarmaClick,
            disabled: isPlayerSpectator || !isKarmaActive || hasUsedDisableKarmaRequest,
            hidden: isReplay || isBeginnerMode
        },
        {
            label: /*#__PURE__*/ React.createElement(T, {
                id: {
                    key: 'strings:rulebook.title'
                }
            }),
            onClick: showRulesPopup,
            hidden: !isRulesOptionVisible
        },
        {
            label: /*#__PURE__*/ React.createElement("div", {
                className: styles.red
            }, /*#__PURE__*/ React.createElement(T, {
                id: {
                    key: 'strings:game.gearIcon.resignGame'
                }
            })),
            onClick: leaveGame,
            hidden: canResign === false || isPlayerSpectator || isReplay
        },
        {
            label: /*#__PURE__*/ React.createElement("div", {
                className: styles.red
            }, /*#__PURE__*/ React.createElement(T, {
                id: {
                    key: 'strings:game.gearIcon.leaveGame'
                }
            })),
            onClick: leaveGame,
            hidden: canResign === true && !isPlayerSpectator
        }
    ];
    return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Dropdown, {
        className: styles.dropdownContainer,
        options: options,
        placement: "right-start"
    }, /*#__PURE__*/ React.createElement("img", {
        className: clsx(styles.settingsButton, className),
        src: IconSettings
    })));
};
